import React from 'react';
import {
  FaCheck,
  FaExclamationCircle,
  FaExclamationTriangle,
} from 'react-icons/fa';
import './CreateCardPopup.css';

interface CreateCardPopupProps {
  type: 'success' | 'error' | 'warning';
  message: string;
  isVisible: boolean;
}

const CreateCardPopup: React.FC<CreateCardPopupProps> = ({
  type,
  message,
  isVisible,
}) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheck />;
      case 'error':
        return <FaExclamationCircle />;
      case 'warning':
        return <FaExclamationTriangle />;
    }
  };

  return (
    <div
      className={`create-card-popup create-card-popup-${type} ${isVisible ? 'create-card-popup-visible' : 'create-card-popup-hidden'}`}
    >
      <div
        className={`create-card-popup-content create-card-popup-${type} ${isVisible ? `create-card-popup-content-visible create-card-popup-content-${type}-visible` : `create-card-popup-content-hidden create-card-popup-content-${type}-hidden`}`}
      >
        <div
          className={`create-card-popup-icon create-card-popup-icon-${type}`}
        >
          {getIcon()}
        </div>
        <div className="create-card-popup-message">{message}</div>
      </div>
    </div>
  );
};

export default CreateCardPopup;
